
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic14On as ObiHydraulic14OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-14-on.js';
 
 
 

 
 export const ObiHydraulic14On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-14-on',
   elementClass: ObiHydraulic14OnElement,
   events: {
     
   }
  });
 
 